module.exports = __webpack_public_path__ + "static/media/heart.7e510dde.svg";